import { createTheme } from '@mui/material/styles';
export const darkTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#75B626',
            contrastText: '#fff',
        },
        secondary: {
            light: '#666',
            main: '#666',
            dark: '#ddd',
            contrastText: '#fff',
        },
    },
});

export const sitesData = [{
    img: '/app/site1.png',
    title: 'Shiraz-Airbase',
    id: '0-0',
    site: 'site1',
    location: "Iran",
    cols: 1,
},

{
    img: '/app/site6.png',
    title: 'Al Asad-Airbase',
    location: "Iraq",
    site: 'site6',
    id: '0-5',
},

{
    img: '/app/site7.png',
    title: 'Bamarni-Airbase',
    location: "Iraq",
    site: 'site7',
    id: '0-6',
},
{
    img: '/app/site0.png',
    title: 'Custom Images',
    location: "Worldwide",
    site: 'site9',
    id: '0-6',
},

];